import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Confirmation } from "./EventDetail";

export default function ManageRegistration() {
  const { token } = useParams();
  const [reg, setReg] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = async () => {
    try { const { data } = await api.get(`/content/registrations/manage/${token}`); setReg({ ...data, manage_token: token, manage_path: `/gather/manage/${token}` }); }
    catch { setReg(null); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10 lg:py-16" data-testid="manage-registration-page">
      <div className="eyebrow mb-2">Gather</div>
      <h1 className="font-serif text-3xl mb-6" style={{ color: "var(--burgundy)" }}>Your registration.</h1>
      {loading ? null : !reg ? (
        <div className="rounded-2xl border p-8 text-center" style={{ background: "var(--bg-cream-card)", borderColor: "var(--border-cream)" }}>
          <p className="font-serif text-lg" style={{ color: "var(--burgundy)" }}>This link is not valid.</p>
          <Link to="/gather" className="ink-link text-sm" style={{ color: "var(--burgundy)" }}>Back to Gather →</Link>
        </div>
      ) : <Confirmation reg={reg} manageMode onCancelled={load} />}
    </div>
  );
}
